import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import KpiPage from '../../pages/LeadsPage/ScoreConfigPage/ScoreConfigPage';
import { getScores, putScore, postProcess } from '../../services/scoreServices';
import { swalMessages } from '../../constants';

const initialScores = {
  fecha_final: '',
  fecha_inicial: '',
  id: '',
  tasa_conversion_peso: '',
  tasa_conversion_tiempo_ejecucion: '',
  tiempo_gestion_horas_max: '',
  tiempo_gestion_horas_min: '',
  tiempo_gestion_peso: '',
  tiempo_gestion_tiempo_ejecucion: '',
};

const KpisContainer = () => {
  const [scores, setScores] = useState(initialScores);
  const [loading, setLoading] = useState(false);

  const gettingScores = async () => {
    const response = await getScores();
    if (response) {
      const score = response.pop();
      setScores(score);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const onSubmitScore = async (event) => {
    event.preventDefault();
    setLoading(true);
    const { success } = await putScore({
      ...scores,
    });
    if (success) {
      setLoading(false);
      swal(swalMessages.SUCCESSFUL_MESSAGE);
    } else {
      setLoading(false);
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const onSubmitProcess = async (event) => {
    event.preventDefault();
    setLoading(true);
    const response = await postProcess({
      ...scores,
    });
    if (response) {
      setLoading(false);
      swal(swalMessages.SUCCESSFUL_MESSAGE);
    } else {
      setLoading(false);
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const onChangeScores = (value, field) => {
    setScores({ ...scores, [field]: value });
  };

  useEffect(() => {
    gettingScores();
  }, []);

  return (
    <KpiPage
      scores={scores}
      loading={loading}
      onSubmitScore={onSubmitScore}
      onChangeScores={onChangeScores}
      onSubmitProcess={onSubmitProcess}
    />
  );
};

export default KpisContainer;
